<cdk-virtual-scroll-viewport
  itemSize="37"
  minBufferPx="900"
  maxBufferPx="1350"
  [ngStyle]="{
    height: options.length * 37 + 8 + 'px',
    maxHeight: '555px',
    overflow: 'hidden'
  }"
>
  <ion-list style="padding: 4px 0">
    <ion-item
      *cdkVirtualFor="let opt of options; let i = index"
      button="true"
      (click)="didClick($event, i, opt.label, opt.id, opt.metadata)"
      class="ion-item-rounded {{ itemClass ? itemClass : '' }}{{
        opt.destructive ? ' destructive' : ''
      }}"
      [id]="
        opt.subOptions && opt.subOptions.length > 0
          ? 'sub-trigger-' + i
          : opt.id
      "
    >
      <ion-label style="margin-left: 5px">
        <ion-icon
          *ngIf="opt.icon && !opt.emoji"
          name="{{ opt.icon }}"
          class="action-icon"
        ></ion-icon>
        <ng-container *ngIf="opt.emoji | colonToEmoji as emojiString">
          <img
            *ngIf="isURL(emojiString)"
            [src]="emojiString"
            alt="Emoji"
            class="action-icon"
            style="width: 1.5em; height: 1em; vertical-align: -0.125em"
          />
          <span *ngIf="!isURL(emojiString)" class="action-icon">{{
            emojiString
          }}</span>
        </ng-container>
        {{ opt.label }}
        <span *ngIf="opt.description" class="action-description">{{
          " - " + opt.description
        }}</span>
      </ion-label>
      <ion-icon
        *ngIf="opt.subOptions && opt.subOptions.length > 0"
        name="chevron-forward"
        slot="end"
        class="sub-options-indicator"
      ></ion-icon>

      <!-- Nested popover for items with sub-options -->
      <ion-popover
        *ngIf="opt.subOptions && opt.subOptions.length > 0"
        [trigger]="'sub-trigger-' + i"
        [dismissOnSelect]="true"
        side="right"
        alignment="start"
        [showBackdrop]="false"
        class="sub-options-popover"
      >
        <ng-template>
          <ion-content>
            <ion-list style="padding: 4px 0">
              <ion-item
                *ngFor="let subOpt of opt.subOptions; let subIndex = index"
                button="true"
                (click)="
                  didClickSubOption(
                    i,
                    subIndex,
                    subOpt.label,
                    subOpt.id,
                    subOpt.metadata
                  )
                "
                [id]="subOpt.id"
                class="ion-item-rounded {{ itemClass ? itemClass : '' }}{{
                  subOpt.destructive ? ' destructive' : ''
                }}"
              >
                <ion-label>
                  <ion-icon
                    *ngIf="subOpt.icon && !subOpt.emoji"
                    name="{{ subOpt.icon }}"
                    class="action-icon"
                  ></ion-icon>
                  <ng-container
                    *ngIf="subOpt.emoji | colonToEmoji as emojiString"
                  >
                    <img
                      *ngIf="isURL(emojiString)"
                      [src]="emojiString"
                      alt="Emoji"
                      class="action-icon"
                      style="
                        width: 1.5em;
                        height: 1em;
                        vertical-align: -0.125em;
                      "
                    />
                    <span *ngIf="!isURL(emojiString)" class="action-icon">{{
                      emojiString
                    }}</span>
                  </ng-container>
                  {{ subOpt.label }}
                  <span *ngIf="subOpt.description" class="action-description">{{
                    " - " + subOpt.description
                  }}</span>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-content>
        </ng-template>
      </ion-popover>
    </ion-item>
  </ion-list>
</cdk-virtual-scroll-viewport>
